<template>

  <div v-if="! noContent">
    <div class="row">
      <div class="col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo" v-if="showContent">{{ title }}</h2>
        <router-link v-if="showContent" :to="getUrlLocutor(locutor)" v-for="(locutor , index) in items"
                     :key="index">
          <div class="locutor">
            <img v-if="locutor.imageLocutor" :src="locutor.imageLocutor">
            <span>{{ locutor.nameLocutor }}</span>
            <p>{{ locutor.descriptionLocutor }}</p>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';
  import {slugify} from '../../helpers/slugify';

  export default {
    components: {
      Loading
    },
    props: ['bloco'],
    data() {
      return {
        title: 'Locutor online',
        items: [],
        item: {},
        showContent: true,
        noContent: false,
        now: new Date(),
      }
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      let self = this;

      // get('content/' + this.bloco.id).then(function (response) {
      // self.items = response.data.result.data;
      self.items = this.$store.getters['getSiteContent'].result.data.locutor;
      if (self.items.length === 0) {
        self.noContent = true;
      }
      // });
    },
    methods: {
      getUrlLocutor(locutor) {
        return '/locutor/' + locutor.idLocutor + '/' + slugify(locutor.nameLocutor);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/LocutorOnline.vue